import classNames from 'classnames'
import React, { useContext, useState } from 'react'
import closeModalIcon from '../../assets/closeModal.svg'

import avatar1 from '../../assets/avatar/avatar1.png'
import avatar2 from '../../assets/avatar/avatar2.png'
import avatar3 from '../../assets/avatar/avatar3.png'
import avatar4 from '../../assets/avatar/avatar4.png'
import avatar5 from '../../assets/avatar/avatar5.png'
import avatar6 from '../../assets/avatar/avatar6.png'
import avatar7 from '../../assets/avatar/avatar7.png'
import avatar8 from '../../assets/avatar/avatar8.png'
import avatar9 from '../../assets/avatar/avatar9.png'
import avatar10 from '../../assets/avatar/avatar10.png'
import avatar11 from '../../assets/avatar/avatar11.png'
import avatar12 from '../../assets/avatar/avatar12.png'
import avatar13 from '../../assets/avatar/avatar13.png'
import avatar14 from '../../assets/avatar/avatar14.png'
import avatar15 from '../../assets/avatar/avatar15.png'
import avatar16 from '../../assets/avatar/avatar16.png'
import avatar17 from '../../assets/avatar/avatar17.png'
import avatar18 from '../../assets/avatar/avatar18.png'
import avatar19 from '../../assets/avatar/avatar19.png'
import avatar20 from '../../assets/avatar/avatar20.png'
import avatar21 from '../../assets/avatar/avatar21.png'
import avatar22 from '../../assets/avatar/avatar22.png'
import avatar23 from '../../assets/avatar/avatar23.png'
import avatar24 from '../../assets/avatar/avatar24.png'
import avatar27 from '../../assets/avatar/avatar27.png'
import avatar28 from '../../assets/avatar/avatar28.png'
import avatarUniSexe from '../../assets/avatarUniSexe.svg'

interface Props {
  isOpen: boolean
  closeModal: () => void
  
  selectedImageId:any
  handleImageClick:any
  newImage:any
  setNewImage:(id: number)=>void
  updateAvatar:any
}

const ImageUserUpdate: React.FC<Props> = ({ 
  isOpen, closeModal, selectedImageId ,handleImageClick, newImage, setNewImage, updateAvatar 
  }) => {
  
  if (!isOpen) return null

  const dataAvatar = [
    { index: 1, image: avatar1 },
    { index: 2, image: avatar2 },
    { index: 3, image: avatar3 },
    { index: 4, image: avatar4 },
    { index: 5, image: avatar5 },
    { index: 6, image: avatar6 },
    { index: 7, image: avatar7 },
    { index: 8, image: avatar8 },
    { index: 9, image: avatar9 },
    { index: 10, image: avatar10 },
    { index: 11, image: avatar11 },
    { index: 12, image: avatar12 },
    { index: 13, image: avatar13 },
    { index: 14, image: avatar14 },
    { index: 15, image: avatar15 },
    { index: 16, image: avatar16 },
    { index: 17, image: avatar17 },
    { index: 18, image: avatar18 },
    { index: 19, image: avatar19 },
    { index: 20, image: avatar20 },
    { index: 21, image: avatar21 },
    { index: 22, image: avatar22 },
    { index: 23, image: avatar23 },
    { index: 24, image: avatar24 },
    { index: 27, image: avatar27 },
    { index: 28, image: avatar28 },
    { index: 0, image: avatarUniSexe },
  ]

  const setNewImageAndCloseModal = () => {
    if (selectedImageId !== null) {
      const selectedImage = dataAvatar.find((image: any) => image.index === selectedImageId)
      if (selectedImage) {
           setNewImage(selectedImageId)
        closeModal()
      }
    }
  }

  return (
    <div>
      <div className={classNames('justify-center items-center flex fixed inset-0 z-50 bg-[#4945c12f] backdrop-blur-sm')}>
        <div className="relative my-6 mx-auto max-w-3xl">
          
        <div className={classNames(' rounded-2xl shadow-xl relative   flex flex-col w-[452px] sm:w-[350px] h-[560px]  bg-[#FFFFFF]',)}>
          
        <img
            src={closeModalIcon}
            width={20}
            height={20}
            onClick={() => {
              closeModal()
            }}
            className="right-8 top-6 absolute hover:cursor-pointer"
          />

          <div className=" mt-10 h-full  no-scrollbar overflow-y-auto">
            <div className="flex flex-wrap justify-center">
              {dataAvatar.map((imageList: any, index: number) => (
                <div key={index}>
                  
                  <img
                    src={imageList.image}
                    className={`w-[75px] h-[75px] m-5 sm:m-2 cursor-pointer ${selectedImageId === imageList.index ? 'border-4 rounded-full border-[#4945c1]' : ''}`}
                    onClick={() => handleImageClick(imageList.index)}
                    alt='choix des avatars'
                  />
                </div>
              ))}
            </div>
          </div>
            <button
              className="bg-[#4743C9] text-white font-bold text-[20px] w-[70%] rounded-xl py-4  mx-auto my-6"
              onClick={()=>{
                setNewImageAndCloseModal()
                updateAvatar()
            }}
            >
              Ajouter
            </button>
        </div>

          
        </div>
      </div>
    </div>
  )
}

export default ImageUserUpdate
